<template>
    <div class="contract-body">
        <!-- 搜索 -->
        <div class="search-wrap">
            <el-button size="mini" type="primary" @click="editArea()" icon="el-icon-plus">添加行业</el-button>
            <!-- <el-input size="mini" placeholder="请输入搜关键字" v-model="keyword" clearable style="width: 200px"></el-input>
        <el-button size="mini" type="primary" @click="search()" :loading="searchLoading">搜索</el-button> -->
        </div>
        <!-- 区域树 -->
        <div class="area-wrap">
            <el-tree :props="props" :load="getNodeData" :data="data" node-key="id" :empty-text="emptyText" lazy
                :highlight-current="true" :default-expanded-keys="defExpKeys" @node-expand="nodeExpand"
                @node-collapse="nodeCollapse">
                <div class="custom-tree-node" slot-scope="{ node, data }">
                    <div class="area-info">{{ node.label }}<span class="area-manager">{{ data.manager }}</span></div>
                    <div class="area-opt">
                        <el-tag size="mini" @click="(e) => addNode(e, { id: data.id })"><i
                                class="el-icon-plus"></i>添加</el-tag>
                        <el-tag size="mini" @click="(e) => editNode(e, data)"><i class="el-icon-edit"></i>编辑</el-tag>
                        <!--            <el-tag type="danger" size="mini" @click="(e) => removeArea(e, data)"><i class="el-icon-delete"></i>删除</el-tag>-->
                    </div>
                </div>
            </el-tree>
        </div>
        <!-- 添加窗口 -->
        <el-dialog title="添加行业" :visible.sync="dialogVisible" :close-on-click-modal="true" class="area-dialog"
            width="600px">
            <el-form ref="form" :rules="rules" :model="form" label-width="100px" size="mini" class="area-form">
                <el-form-item label="行业名称" prop="">
                    <el-input v-model="form.name" placeholder="请填写行业名称"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submit()" :loading="submitLoading">确 定</el-button>
                <el-button @click="dialogVisible = false">取 消</el-button>
            </div>
        </el-dialog>
        <area-selector :visible.sync="areaSelectorVisible" @selected="areaSelected"></area-selector>
    </div>
</template>
<script>
import AreaSelector from './AreaSelector.vue'
import { Area } from './js/common.js'
import xhHelp from "./xhHelp"
export default {
    name: "ContractArea",
    components: {
        'area-selector': AreaSelector
    },
    data() {
        return {
            keyword: '',
            searchLoading: false,
            submitLoading: false,
            dialogVisible: false,
            areaSelectorVisible: false,
            form: {
                id: '',
                name: ''
            },
            type:'',
            // defValue: {
            //     id: '',
            //     parent_id: '',
            //     parent_name: '-',
            //     name: '',
            //     manager: '',
            //     remark: '',
            // },
            rules: {
                name: [
                    { required: true, message: '请输入行业名称。', trigger: 'blur' },
                ],
            },

            props: {
                label: 'name',
                children: 'children',
                isLeaf: 'leaf',
            },
            data: [],
            emptyText: '',
            defEmptyText: '暂无数据',
            defExpKeys: [],
        }
    },
    mounted() {
        this.myGetList();
    },
    beforeMount() {
    },
    watch: {

    },
    created() {
    },
    methods: {

        //行业列表
        myGetList(params, url) {
          const that = this;
          xhHelp.get('Industry/index', params,res=>{
                if (res) {
                 this.data = res.data;
                }
              })

        },
        //添加顶级行业
        addIndustry(type = '') {
          let url = (type === 'edit'?'Industry/edit':(this.form.id?'Industry/saveNode':'Industry/save'))
              console.log('url_' +url )
            xhHelp.post(url,  this.form,res=>{
              //拿到回调
              console.log('----1-')
              console.log(res)
              if (res.code === 0) {
                  this.$message({
                      message: res.message,
                      type: "success",
                  });
                  //回到列表
                  // this.addUserForm = false;
                  this.dialogVisible = false;
                  this.myGetList();

              } else {
                  this.$message.error({
                      message: res.message,
                      type: "error",
                  });
              }
            })
        },
        //节点下面的数据
        getNodeData(node, resolve) {
            console.log(node.level, node.data)
            var region_id = node.data.id;//选中节点id
            console.log(region_id);
            var _this = this;
            setTimeout(() => {
                //节点不能为空
                if (region_id === '' || region_id === undefined) {
                    return false;
                }
                //加载
                node.data.region_id = region_id;

                // node.data && this.$myhttp.get('https://mt.51homemoney.com/api/Industry/node', { params: { id: node.data.id, } }, {
                //     'Content-Type': 'application/json'
                // }).then(backdata => { // 异步执行成功后
                //     // _this.defaultcheckedkeys =  _this.arr;
                //     console.log(backdata.data.data);
                //     return resolve(backdata.data.data);
                // });

                node.data && xhHelp.get('Industry/node', { id: node.data.id },res=>{
                  console.log(res.data);
                  return resolve(res.data);
                })

            }, 300);

        },
        //给某个行业 添加节点
        addNode(e, data) {
            var id = data.id;
            console.log('addNode');
            console.log(id);
            this.dialogVisible = true;
            this.form.id = id;
            this.form.name = '';
            this.type = '';
            console.log(this.form);
        },
        //修改节点
        editNode(e, data) {
            var id = data.id;
            console.log('editNode');
            // console.log(e);
            console.log(data.name);
            this.dialogVisible = true;
            this.form.id = id;
            this.form.name = data.name;
            this.type = 'edit';

        },
        search() {

        },
        editArea(e, data) {
            this.form.id = "";
            this.form.name = '';
            this.type = '';
            this.dialogVisible = true
            // if (e) e.stopPropagation()
        },
        removeArea(e, data) {
            this.$confirm(`此操作将删除 [ ${data.name} ] 及其子区域，是否继续?`, '提示', { type: 'warning' }).then(() => {
                console.log('待写')
            })
            e.stopPropagation()
        },
        submit() {
            console.log('submit');
            console.log(this.form);
            console.log(this.type)
            if(this.type==='edit'){
                this.addIndustry(this.type);
            }else{
              this.addIndustry();
            }
        },
        areaSelected(data) {
            if (data.id === this.form.id) {
                this.$message.error('上级不能选择自己')
                return false
            }
            this.form.parent_id = data.id
            this.getAreaFullName()
        },
        getAreaFullName() {
            let that = this
            if (that.form.parent_id === '') return false
            Area.getAreaFullName({ id: that.form.parent_id }, res => {
                that.form = Object.assign({}, that.form, { parent_name: res.data.join(' -> ') })
            })
        },
        loadNode(node, resolve) {

            if (node.data.id) {
                Area.getAreaList({ parent_id: node.data.id }, res => {
                    resolve(res.data)
                })
            }
        },
        nodeExpand(data, node, obj) {
            if (this.defExpKeys.includes(node.key) === false) {
                this.defExpKeys.push(node.key)
            }
        },
        nodeCollapse(data, node) {
            // let k = this.defExpKeys.indexOf(node.key)
            // if (k !== -1) this.defExpKeys.splice(k, 1)
        }
    }
}
</script>
<style lang="scss" scoped>
@import './js/common2.scss';

.area-dialog {
    .area-form {
        margin-right: 50px;
    }
}

.area-wrap {
    margin-top: 15px;
    max-width: 600px;
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 5px;
    overflow: auto;
    height: 600px;
}

/deep/.custom-tree-node {
    flex: 1;
    display: flex;
    justify-content: space-between;

    .area-info {
        font-size: 14px;
    }

    .area-manager {
        padding-left: 5px;
        color: #999;
    }

    .area-opt {
        margin-right: 5px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/App/Card/Industry.vue